import fr from 'facet-rest';

const DependentsOverride = fr.metaOverride()
  .nameOverride('firstName', { ordinal: 1 })
  .nameOverride('lastName', { ordinal: 2 })
  .nameOverride('birthdate', { ordinal: 3 });


export default DependentsOverride;
